// extracted by mini-css-extract-plugin
export var bubble = "_2w-0";
export var container = "_2w-f";
export var contrastBorder = "_2w-g";
export var greyOut = "_2w-2";
export var initialsColor0 = "_2w-3";
export var initialsColor1 = "_2w-4";
export var initialsColor10 = "_2w-d";
export var initialsColor11 = "_2w-e";
export var initialsColor2 = "_2w-5";
export var initialsColor3 = "_2w-6";
export var initialsColor4 = "_2w-7";
export var initialsColor5 = "_2w-8";
export var initialsColor6 = "_2w-9";
export var initialsColor7 = "_2w-a";
export var initialsColor8 = "_2w-b";
export var initialsColor9 = "_2w-c";
export var initialsWrapper = "_2w-1";
export var large = "_2w-l";
export var medium = "_2w-k";
export var mediumSmall = "_2w-j";
export var mediumSmallMedium = "_2w-o";
export var micro = "_2w-h";
export var small = "_2w-i";
export var tiny = "_2w-n";
export var xTiny = "_2w-m";